import { PublicClientApplication } from '@azure/msal-browser';
import { message, notification } from 'antd';
import React from 'react';
import * as ACTION from '../constants/action.types';
import {
  AZURE_APP_ID,
  AZURE_USER_NAME,
  NOTIFIES,
} from '../constants/system.keys';

export const loadingState = (state, metadata) => {
  return {
    ...state,
    status: 'loading',
    metadata,
    error: undefined,
  };
};

export const successState = (state, data) => {
  return {
    ...state,
    status: 'success',
    data,
    error: undefined,
  };
};

export const errorState = (state, error) => {
  return {
    ...state,
    status: 'error',
    error,
  };
};

export const socketEmitEvent = (data) => ({
  type: ACTION.SOCKET_EMIT,
  payload: data,
});
export const changeLocales = (data) => ({
  type: ACTION.UPDATE_LOCALE,
  payload: data,
});
export const updateNamespace = (data, action = '') => ({
  type: ACTION.UPDATE_NAMESPACE,
  payload: {
    data,
    action,
  },
});

export const openMessage = (type, description) => {
  return message[type]({
    content: description,
    style: {
      marginTop: '85vh',
      marginLeft: '78%',
    },
  });
};
export const openNotification = (
  type,
  description,
  image,
  data,
  onChangeModal,
) => {
  if (image) {
    return notification[type]({
      message: 'Notification',
      description: (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>{description}</div>
          <img
            src={image}
            alt=""
            style={{
              width: '115px',
              height: '65px',
              objectFit: 'cover',
              margin: '-25px 20px 0 0',
            }}
            onClick={() => onChangeModal(data)}
          />
        </div>
      ),
      placement: 'bottomRight',
      duration: 4,
    });
  } else {
    return notification[type]({
      message: 'Notification',
      description,
      placement: 'bottomRight',
      duration: 4,
    });
  }
};
export const updateSocketState = (payload) => ({
  type: ACTION.UPDATE_SOCKET_STATE,
  payload,
});
export const authReturnToken = (payload) => ({
  type: ACTION.AUTH_RETURN_TOKEN,
  payload,
});
export const authInvalidReturn = (payload) => ({
  type: ACTION.AUTH_INVALID_RETURN,
  payload,
});
export const authLoginReturn = (payload) => ({
  type: ACTION.AUTH_LOGIN_RETURN,
  payload,
});
export const authLogOut = () => ({
  type: ACTION.AUTH_LOG_OUT,
});
export const getPublicIpReturn = (payload) => ({
  type: ACTION.GET_PUBLIC_IP,
  payload,
});
export const getUserInfoReturn = (payload) => ({
  type: ACTION.GET_USER_INFO_RETURN,
  payload,
});

export const deviceChangeStateReturn = (payload) => ({
  type: ACTION.DEVICE_CHANGE_STATE_RETURN,
  payload,
});

export const updateNotificationDeviceOnMaps = (payload) => ({
  type: ACTION.UPDATE_NOTIFICATION_DEVICE_ON_MAPS,
  payload,
});

export const autoRemoveOldNotifyDeviceOnMaps = (payload) => ({
  type: ACTION.AUTO_REMOVE_NOTIFY_DEVICE_ON_MAP,
  payload,
});

export const devicesMapReturn = (payload) => ({
  type: ACTION.DEVICES_MAP_RETURN,
  payload,
});
export const getListCameraByPageReturn = (payload) => ({
  type: ACTION.LIST_CAMERA_BY_PAGE_RETURN,
  payload,
});
export const resetCameraByPageReturn = (payload) => ({
  type: ACTION.RESET_CAMERA_BY_PAGE_RETURN,
  payload,
});
export const getListGatewayByPageReturn = (payload) => ({
  type: ACTION.LIST_GATEWAY_BY_PAGE_RETURN,
  payload,
});
export const getStateCamerasReturn = (payload) => ({
  type: ACTION.LIST_STATE_CAMERA_RETURN,
  payload,
});
export const getStateGatewaysReturn = (payload) => ({
  type: ACTION.LIST_STATE_GATEWAY_RETURN,
  payload,
});
export const searchDeviceByNameReturn = (payload) => ({
  type: ACTION.SEARCH_DEVICE_BY_NAME_RETURN,
  payload,
});
export const gatewayUpdateInfoReturn = (payload) => ({
  type: ACTION.GATEWAY_UPDATE_INFO_RETURN,
  payload,
});
export const cameraUpdateInfoReturn = (payload) => ({
  type: ACTION.CAMERA_UPDATE_INFO_RETURN,
  payload,
});
export const updateDeviceReturn = (payload) => ({
  type: ACTION.UPDATE_DEVICE_RETURN,
  payload,
});
export const removeDeviceReturn = (payload) => ({
  type: ACTION.REMOVE_DEVICE_RETURN,
  payload,
});

export const listCameraStorageReturn = (payload) => ({
  type: ACTION.LIST_CAMERA_STORAGE_RETURN,
  payload,
});
export const resetCameraStorageReturn = (payload) => ({
  type: ACTION.RESET_CAMERA_STORAGE_RETURN,
  payload,
});
export const generateLinkStorageFileReturn = (payload) => ({
  type: ACTION.GENERATE_LINK_STORAGE_FILE_RETURN,
  payload,
});
export const getDeviceInfoExtraReturn = (payload) => ({
  type: ACTION.GET_DEVICE_INFO_EXTRA_RETURN,
  payload,
});

export const listDeviceAndShareExtendReturn = (payload) => ({
  type: ACTION.LIST_DEVICE_AND_SHARE_EXTEND_RETURN,
  payload,
});
export const requireActiveDeviceReturn = (payload) => ({
  type: ACTION.REQUIRE_ACTIVE_DEVICE_RETURN,
  payload,
});
export const checkExternalDeviceReturn = (payload) => ({
  type: ACTION.CHECK_EXTERNAL_DEVICE_RETURN,
  payload,
});
export const checkStreamReturn = (payload) => ({
  type: ACTION.CHECK_STREAM_RETURN,
  payload,
});
export const clearStreamReturn = (payload) => ({
  type: ACTION.CLEAR_STREAM_RETURN,
  payload,
});
export const checkRtspStreamReturn = (payload) => ({
  type: ACTION.CHECK_RTSP_STREAM_RETURN,
  payload,
});
export const checkFaceTerminalReturn = (payload) => ({
  type: ACTION.CHECK_FACE_TERMINAL_RETURN,
  payload,
});
export const scanStreamReturn = (payload) => ({
  type: ACTION.SCAN_STREAM_RETURN,
  payload,
});
export const addExternalDeviceReturn = (payload) => ({
  type: ACTION.ADD_EXTERNAL_DEVICE_RETURN,
  payload,
});

export const getListUserShareDeviceReturn = (payload) => ({
  type: ACTION.LIST_USER_SHARE_DEVICE_RETURN,
  payload,
});
export const getListAccountByDeviceGroupReturn = (payload) => ({
  type: ACTION.LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE_RETURN,
  payload,
});
export const sharePermissionUserReturn = (payload) => ({
  type: ACTION.SHARE_PERMISSION_USER,
  payload,
});
export const unSharePermissionUserReturn = (payload) => ({
  type: ACTION.UN_SHARE_PERMISSION_USER_RETURN,
  payload,
});
export const requireAddDeviceReturn = (payload) => ({
  type: ACTION.REQUIRE_ADD_DEVICE_RETURN,
  payload,
});
export const getCreateStreamReturn = (payload) => ({
  type: ACTION.CREATE_STREAM,
  payload,
});
export const getStartStreamMonitorReturn = (payload) => ({
  type: ACTION.START_STREAM_MONITOR,
  payload,
});
export const getStartStreamMonitorFailure = (payload) => ({
  type: ACTION.START_STREAM_MONITOR_FAILURE,
  payload,
});
export const removeStartStreamMonitorFailure = (payload) => ({
  type: ACTION.REMOVE_START_STREAM_MONITOR_FAILURE,
  payload,
});
export const removeStream = (payload) => ({
  type: ACTION.REMOVE_STREAM,
  payload,
});
export const getCreateRtspStreamReturn = (payload) => ({
  type: ACTION.CREATE_RTSP_STREAM,
  payload,
});
export const reConnectStreamReturn = (payload) => ({
  type: ACTION.RECONNECT_STREAM,
  payload,
});

export const getWatchStreamReturn = (payload) => ({
  type: ACTION.WATCH_STREAM,
  payload,
});
export const getStartStreamReturn = (payload) => ({
  type: ACTION.START_STREAM,
  payload,
});
export const getEndStreamReturn = (payload) => ({
  type: ACTION.END_STREAM,
  payload,
});
export const getEndStreamUtraFastReturn = (payload) => ({
  type: ACTION.END_STREAM_ULTRA_FAST,
  payload,
});
export const updateStreamInfoReturn = (payload) => ({
  type: ACTION.UPDATE_STREAM_INFO,
  payload,
});
export const getClearStreamReturn = () => ({
  type: ACTION.CLEAR_STREAM,
});

export const listSearchContactReturn = (payload) => ({
  type: ACTION.SEARCH_CONTACT_RETURN,
  payload,
});
export const getListNotificationReturn = (payload) => ({
  type: ACTION.LIST_NOTIFICATION_RETURN,
  payload,
});
export const updateNotificationStatus = (payload) => ({
  type: ACTION.UPDATE_NOTIFICATION_RETURN,
  payload,
});
export const markReadNotification = (payload) => ({
  type: ACTION.MARK_READ_NOTIFICATION_RETURN,
  payload,
});
export const getNewNotificationReturn = (payload) => ({
  type: ACTION.NEW_NOTIFICATION_RETURN,
  payload,
});
export const resetTotalUnReadNotification = (payload) => ({
  type: ACTION.RESET_TOTAL_UNREAD_NOTIFICATION_RETURN,
  payload,
});
export const getNewNotificationDetailReturn = (payload) => ({
  type: ACTION.NEW_NOTIFICATION_DETAIL_RETURN,
  payload,
});
export const getFilterNotificationReturn = (payload) => ({
  type: ACTION.FILTER_NOTIFICATION_RETURN,
  payload,
});
export const getListServiceReturn = (payload) => ({
  type: ACTION.LIST_SERVICE_RETURN,
  payload,
});
export const getListServicebyDeviceSerialReturn = (payload) => ({
  type: ACTION.LIST_SERVICE_BY_DEVICE_SERIAL_RETURN,
  payload,
});
export const getListDeviceByServiceIdReturn = (payload) => ({
  type: ACTION.LIST_DEVICE_BY_SERVICE_ID_RETURN,
  payload,
});
export const getListTargetByServiceIdReturn = (payload) => ({
  type: ACTION.LIST_TARGET_BY_SERVICE_ID_RETURN,
  payload,
});
export const getListDeviceActiveByServiceIdReturn = (payload) => ({
  type: ACTION.LIST_DEVICE_ACTIVE_SERVICE_ID_RETURN,
  payload,
});
export const getListTargetActiveByServiceIdReturn = (payload) => ({
  type: ACTION.LIST_TARGET_ACTIVE_SERVICE_ID_RETURN,
  payload,
});
export const getLicenseInfoServiceReturn = (payload) => ({
  type: ACTION.GET_LICENSE_INFO_SERVICE_RETURN,
  payload,
});
export const activeLicenseServiceReturn = (payload) => ({
  type: ACTION.ACTIVE_LICENSE_SERVICE_RETURN,
  payload,
});
export const cancelLicenseServiceReturn = (payload) => ({
  type: ACTION.CANCEL_LICENSE_SERVICE_RETURN,
  payload,
});
export const getListAccountByNamespaceReturn = (payload) => ({
  type: ACTION.LIST_ACCOUNT_BY_NAMESPACE_RETURN,
  payload,
});
export const getListAccountByNamespaceByPageReturn = (payload) => ({
  type: ACTION.LIST_ACCOUNT_BY_NAMESPACE_BY_PAGE_RETURN,
  payload,
});
export const getListDetailRoleOfCustomerReturn = (payload) => ({
  type: ACTION.LIST_DETAIL_ROLE_OF_CUSTOMER_RETURN,
  payload,
});
export const getListNamespaceReturn = (payload) => ({
  type: ACTION.LIST_NAMESPACE_RETURN,
  payload,
});
export const getActionLogByNamespaceReturn = (payload) => ({
  type: ACTION.LIST_ACTION_LOG_BY_NAMESPACE_RETURN,
  payload,
});
export const getWhiteListIpReturn = (payload) => ({
  type: ACTION.LIST_WHITE_LIST_IP_BY_NAMESPACE_RETURN,
  payload,
});
export const createWhitelistIpReturn = (payload) => ({
  type: ACTION.ADD_WHITE_LIST_IP_RETURN,
  payload,
});
export const deleteWhitelistIpReturn = (payload) => ({
  type: ACTION.DELETE_WHITE_LIST_IP_RETURN,
  payload,
});
export const addMemberToNamespaceReturn = (payload) => ({
  type: ACTION.ADD_MEMBER_TO_NAMESPACE_RETURN,
  payload,
});
export const updateMemberToNamespaceReturn = (payload) => ({
  type: ACTION.UPDATE_MEMBER_TO_NAMESPACE_RETURN,
  payload,
});

export const updatePasswordMemberToNamespaceReturn = (payload) => ({
  type: ACTION.UPDATE_PASSWORD_MEMBER_TO_NAMESPACE_RETURN,
  payload,
});

export const removeMemberToNamespaceReturn = (payload) => ({
  type: ACTION.REMOVE_MEMBER_TO_NAMESPACE_RETURN,
  payload,
});
export const onResetTokenReturn = (payload) => ({
  type: ACTION.RESET_TOKEN_RETURN,
  payload,
});
export const onRenewTokenReturn = (payload) => ({
  type: ACTION.RENEW_API_TOKEN_RETURN,
  payload,
});

export const getSumaryCamera = (payload) => ({
  type: ACTION.GET_SUMARY_CAMERA_RETURN,
  payload,
});

export const getListLicenseByNamespace = (payload) => ({
  type: ACTION.GET_LIST_LICENSE_BY_NAMESPACE,
  payload,
});

export const getListDeviceGroup = (payload) => ({
  type: ACTION.GET_LIST_DEVICE_GROUP,
  payload,
});

export const getDeviceGroupById = (payload) => ({
  type: ACTION.GET_DEVICE_GROUP_BY_ID,
  payload,
});

export const getListDeviceGroupByPage = (payload) => ({
  type: ACTION.GET_LIST_DEVICE_GROUP_BY_PAGE,
  payload,
});

export const getListDeviceByDeviceGroupId = (payload) => ({
  type: ACTION.LIST_DEVICE_BY_DEVICE_GROUP_ID_RETURN,
  payload,
});

export const addDeviceGroup = (payload) => ({
  type: ACTION.ADD_DEVICE_TO_GROUP,
  payload,
});

export const updateDeviceGroup = (payload) => ({
  type: ACTION.UPDATE_DEVICE_TO_GROUP,
  payload,
});

export const deleteDeviceGroup = (payload) => ({
  type: ACTION.DELETE_DEVICE_TO_GROUP,
  payload,
});

export const getListCameraSelect = (payload) => ({
  type: ACTION.LIST_DEVICE_SELECT,
  payload,
});

export const clearListCameraSelect = (payload) => ({
  type: ACTION.CLEAR_LIST_DEVICE_SELECT,
  payload,
});

export const getListCameraDate = (payload) => ({
  type: ACTION.LIST_CAMERA_DATE,
  payload,
});

export const getWhiteListDeviceReturn = (payload) => ({
  type: ACTION.LIST_WHITE_LIST_DEVICE_BY_NAMESPACE_RETURN,
  payload,
});
export const createWhitelistDeviceReturn = (payload) => ({
  type: ACTION.ADD_WHITE_LIST_DEVICE_RETURN,
  payload,
});
export const deleteWhitelistDeviceReturn = (payload) => ({
  type: ACTION.DELETE_WHITE_LIST_DEVICE_RETURN,
  payload,
});
export const getGroupMemberReturn = (payload) => ({
  type: ACTION.LIST_GROUP_MEMBER_RETURN,
  payload,
});
export const getDataSearchReturn = (payload) => ({
  type: ACTION.LIST_DATA_SEARCH_RETURN,
  payload,
});
export const addGroupMemberReturn = (payload) => ({
  type: ACTION.ADD_GROUP_MEMBER_RETURN,
  payload,
});
export const updateGroupMemberReturn = (payload) => ({
  type: ACTION.UPDATE_GROUP_MEMBER_RETURN,
  payload,
});
export const deleteGroupMemberReturn = (payload) => ({
  type: ACTION.DELETE_GROUP_MEMBER_RETURN,
  payload,
});
export const getGroupAccountMemberReturn = (payload) => ({
  type: ACTION.LIST_ACCOUNT_GROUP_MEMBER_RETURN,
  payload,
});
export const clearGroupAccountMember = (payload) => ({
  type: ACTION.CLEAR_LIST_ACCOUNT_GROUP_MEMBER,
  payload,
});
export const getListGroupByParentGroupReturn = (payload) => ({
  type: ACTION.LIST_GROUP_BY_PARENT_GROUP_RETURN,
  payload,
});
export const getCheckRemoveGroupReturn = (payload) => ({
  type: ACTION.CHECK_REMOVE_GROUP_RETURN,
  payload,
});
export const clearListGroupByParentGroup = (payload) => ({
  type: ACTION.CLEAR_LIST_GROUP_BY_PARENT_GROUP,
  payload,
});

export const addGroupAccountMemberReturn = (payload) => ({
  type: ACTION.ADD_ACCOUNT_GROUP_MEMBER_RETURN,
  payload,
});
export const deleteAccountGroupMemberReturn = (payload) => ({
  type: ACTION.DELETE_ACCOUNT_GROUP_MEMBER_RETURN,
  payload,
});
export const getSharePermissionGroupReturn = (payload) => ({
  type: ACTION.SHARE_PERMISSION_GROUP_RETURN,
  payload,
});
export const updateSharePermissionGroupReturn = (payload) => ({
  type: ACTION.UPDATE_SHARE_PERMISSION_USER_RETURN,
  payload,
});
export const deleteSharePermissionGroupReturn = (payload) => ({
  type: ACTION.DELETE_SHARE_PERMISSION_GROUP_RETURN,
  payload,
});
export const getDeviceContactInfoReturn = (payload) => ({
  type: ACTION.GET_DEVICE_CONTACT_INFO_RETURN,
  payload,
});
export const getListAlertReturn = (payload) => ({
  type: ACTION.LIST_ALERT_RETURN,
  payload,
});
export const getStatisticActionLogByNamespaceReturn = (payload) => ({
  type: ACTION.STATISTIC_ACTION_LOG_BY_NAMESPACE_RETURN,
  payload,
});
export const getCheckAuthenticationType = (payload) => ({
  type: ACTION.CHECK_AUTHENTICATION_TYPE,
  payload,
});
export const getCheckLdapAccountReturn = (payload) => ({
  type: ACTION.CHECK_LDAP_ACCOUNT_RETURN,
  payload,
});
export const getAuthenticationLdapReturn = (payload) => ({
  type: ACTION.AUTHENTICATION_LDAP_RETURN,
  payload,
});
export const getConfigurationServiceReturn = (payload) => ({
  type: ACTION.CONFIGURATION_SERVICE_RETURN,
  payload,
});
export const reportActionLogReturn = (payload) => ({
  type: ACTION.REPORT_ACTION_LOG_RETURN,
  payload,
});
export const getRequestUploadFileReturn = (payload) => ({
  type: ACTION.REQUEST_UPLOAD_FILE,
  payload,
});
export const getRequestUploadStorageFileReturn = (payload) => ({
  type: ACTION.UPLOAD_STORAGE_FILE,
  payload,
});
export const getResetUploadFileReturn = (payload) => ({
  type: ACTION.RESET_UPLOAD_FILE,
  payload,
});
export const removeStorageFileReturn = (payload) => ({
  type: ACTION.REMOVE_STORAGE_FILE_RETURN,
  payload,
});
export const listStorageFileByTag = (payload) => ({
  type: ACTION.LIST_STORAGE_FILE_BY_TAG,
  payload,
});
export const setListStorageFileByTag = (payload) => ({
  type: ACTION.SET_LIST_STORAGE_FILE_BY_TAG,
  payload,
});
export const updateTagsStorageFile = (payload) => ({
  type: ACTION.UPDATE_TAGS_STORAGE_FILE,
  payload,
});
export const setPlayVideoAtPage = (payload) => ({
  type: ACTION.SET_PLAY_VIDEO_AT_PAGE,
  payload,
});
export const listCameraByState = (payload) => ({
  type: ACTION.LIST_CAMERA_BY_STATE,
  payload,
});
export const listGatewayByState = (payload) => ({
  type: ACTION.LIST_GATEWAY_BY_STATE,
  payload,
});
export const setOpenUploadFilesModal = (payload) => ({
  type: ACTION.SET_OPEN_UPLOAD_FILES_DIALOG,
  payload,
});
export const setUploadFilesCamera = (payload) => ({
  type: ACTION.SET_UPLOAD_FILES_CAMERA,
  payload,
});
export const setUploadFilesOldVideos = (payload) => ({
  type: ACTION.SET_UPLOAD_FILES_OLD_VIDEOS,
  payload,
});
export const setUploadFilesDate = (payload) => ({
  type: ACTION.SET_UPLOAD_FILES_DATE,
  payload,
});
export const setListNotification = (payload) => ({
  type: ACTION.SET_LIST_NOTIFICATION,
  payload,
});
export const deleteListNotification = (payload) => ({
  type: ACTION.DELETE_LIST_NOTIFICATION,
  payload,
});
export const getListDeviceByUserReturn = (payload) => ({
  type: ACTION.LIST_DEVICE_BY_USER_RETURN,
  payload,
});
export const listDeviceGroupByUserReturn = (payload) => ({
  type: ACTION.LIST_DEVICE_GROUP_BY_USER_RETURN,
  payload,
});
export const authLogoutThunk = () => {
  return async (dispatch) => {
    // logout ms azure
    if (
      localStorage.getItem(AZURE_APP_ID) &&
      localStorage.getItem(AZURE_USER_NAME)
    ) {
      const config = {
        auth: {
          clientId: localStorage.getItem(AZURE_APP_ID),
        },
      };
      const myMsal = new PublicClientApplication(config);
      const account = myMsal.getAccountByUsername(
        localStorage.getItem(AZURE_USER_NAME),
      );
      try {
        await myMsal.logoutPopup({
          account,
        });
        localStorage.removeItem(AZURE_APP_ID);
        localStorage.removeItem(AZURE_USER_NAME);
        dispatch(authLogOut());
      } catch (error) {
        openMessage(NOTIFIES.WARNING, error.message);
      }
    } else {
      dispatch(authLogOut());
    }
  };
};
export const getUpdateStateDevicesReturn = (payload) => ({
  type: ACTION.UPDATE_STATE_DEVICES_RETURN,
  payload,
});

export const setPinnedCamerasMode = (payload) => ({
  type: ACTION.SET_PINNED_CAMERAS_MODE_RETURN,
  payload,
});

export const listPlaceByPage = (payload) => ({
  type: ACTION.LIST_PLACE_BY_PAGE,
  payload,
});

export const addPlaceReturn = (payload) => ({
  type: ACTION.ADD_PLACE_RETURN,
  payload,
});

export const removePlaceReturn = (payload) => ({
  type: ACTION.REMOVE_PLACE_RETURN,
  payload,
});

export const requestMakeCallReturn = (payload) => ({
  type: ACTION.REQUEST_MAKE_CALL_RETURN,
  payload,
});

export const changeDialPadData = (payload) => ({
  type: ACTION.CHANGE_DIAL_PAD_DATA,
  payload,
});

export const statisticDeviceStatusReturn = (payload) => ({
  type: ACTION.STATISTIC_DEVICE_STATUS_RETURN,
  payload,
});

export const generateLinkStorageFileByTimeReturn = (payload) => ({
  type: ACTION.GENERATE_LINK_STORAGE_FILE_BY_TIME_RETURN,
  payload,
});

export const popupVideoStorageFileByTimeReturn = (payload) => ({
  type: ACTION.POPUP_VIDEO_STORAGE_FILE_BY_TIME_RETURN,
  payload,
});

export const getListDeviceGroupByParentDeviceGroupSuccess = (payload) => ({
  type: ACTION.GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_SUCCESS,
  payload,
});

export const getListDeviceGroupByParentDeviceGroupReturn = (payload) => ({
  type: ACTION.GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_RETURN,
  payload,
});
export const getListDeviceGroupByParentDeviceGroupFail = (payload) => ({
  type: ACTION.GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_FAIL,
  payload,
});

export const generateShortToken = (payload) => ({
  type: ACTION.GENERATE_SHORT_TOKEN,
  payload,
});

export const generateShortTokenReturn = (payload) => ({
  type: ACTION.GENERATE_SHORT_TOKEN_RETURN,
  payload,
});

export const setShowCritical = (payload) => ({
  type: ACTION.SET_SHOW_CRITICAL,
  payload,
});

export const getListGpsLocation = (payload) => ({
  type: ACTION.GET_LIST_GPS_LOCATION,
  payload,
});
export const getListSpeakerSip = (payload) => ({
  type: ACTION.GET_LIST_SPEAKER_SIP,
  payload,
});

export const getReportByNamespaceReturn = (payload) => {
  return {
    type: ACTION.GET_REPORT_BY_NAMESPACE_RETURN,
    payload,
  };
};

export const getReportByNamespaceSuccess = (payload) => {
  return {
    type: ACTION.GET_REPORT_BY_NAMESPACE_SUCCESS,
    payload,
  };
};

export const updateDeviceReportsCauseReturn = (payload) => {
  return {
    type: ACTION.UPDATE_DEVICE_REPORTS_CAUSE_RETURN,
    payload,
  };
};

export const updateDeviceReportsCauseSuccess = (payload) => {
  return {
    type: ACTION.UPDATE_DEVICE_REPORTS_CAUSE_SUCCESS,
    payload,
  };
};

export const clearListAllDeviceByGroup = (payload) => {
  return {
    type: ACTION.CLEAR_LIST_ALL_DEVICE_BY_GROUP,
    payload,
  };
};

export const detectObject = (payload) => {
  return {
    type: ACTION.DETECT_OBJECT,
    payload,
  };
};

export const detectPerson = (payload) => {
  return {
    type: ACTION.DETECT_PERSON,
    payload,
  };
};

export const detectFace = (payload) => {
  return {
    type: ACTION.DETECT_FACE,
    payload,
  };
};

export const detectWeapon = (payload) => {
  return {
    type: ACTION.DETECT_WEAPON,
    payload,
  };
};

export const detectFire = (payload) => {
  return {
    type: ACTION.DETECT_FIRE,
    payload,
  };
};

export const detectVirtualWall = (payload) => {
  return {
    type: ACTION.DETECT_VIRTUAL_WALL,
    payload,
  };
};

export const recognitionFace = (payload) => {
  return {
    type: ACTION.RECOGNITION_FACE,
    payload,
  };
};
export const detectEventCommon = (payload) => {
  return {
    type: ACTION.DETECT_EVENT_COMMON,
    payload,
  };
};

export const clearAlert = (payload) => {
  return {
    type: ACTION.CLEAR_ALERT,
    payload,
  };
};

export const toggleSmartMode = (payload) => {
  return {
    type: ACTION.TOGGLE_SMART_MODE,
    payload,
  };
};

export const setCameraSerials = (payload) => {
  return {
    type: ACTION.SET_CAMERA_SERIALS,
    payload,
  };
};

export const clearCameraSerials = (payload) => {
  return {
    type: ACTION.CLEAR_CAMERA_SERIALS,
    payload,
  };
};

export const setFilteringAlerts = (payload) => {
  return {
    type: ACTION.SET_FILTERING_ALERTS,
    payload,
  };
};

export const getStartSessionStreamMilestoneReturn = (payload) => {
  return {
    type: ACTION.START_SESSION_STREAM_MILESTONE,
    payload,
  };
};

//////// MILESTONE /////////////
export const updateCandidateWebMileStoneReturn = (payload) => {
  return {
    type: ACTION.UPDATE_CANDIDATE_WEB_MILESTONE,
    payload,
  };
};

export const updateCandidateMileStoneReturn = (payload) => {
  return {
    type: ACTION.UPDATE_CANDIDATES_MILESTONE,
    payload,
  };
};

export const updateAnswerSDPMilestone = (payload) => {
  return {
    type: ACTION.UPDATE_ANSWER_SDP_MILESTONE,
    payload,
  };
};
